import styled from 'styled-components';
import IconButton from '@web-chat-core/ui-kit/core/Button/iconButton';

export const TileMenuIconButton = styled(IconButton)`
    opacity: 0;
    width: 0;
    min-width: 0;
    overflow: visible;
    transition: opacity 0.2s ease-in-out, width 0.2s ease-in-out;
    pointer-events: auto;
    position: relative;

    svg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
        pointer-events: none;
    }

    &:before {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 32px;
        height: 32px;
        z-index: 0;
        pointer-events: auto;
    }

    &:hover,
    &:focus {
        &:before {
            background-color: ${({ theme }) => theme.root.colors.background.sheetOrModal};
        }
    }

    &:active {
        &:before {
            background-color: ${({ theme }) => theme.root.colors.background.sheetOrModal};
        }
    }
`;

export const ParticipantMenuIconButton = styled(IconButton)`
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    padding: 0;

    svg {
        display: block;
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        margin: 0;
    }

    &:before {
        width: 24px;
        height: 24px;
    }
`;

export const TileMenuIconButtonSmall = styled(IconButton)`
    opacity: 0;
    width: 0;
    min-width: 0;
    height: 24px;
    overflow: visible;
    transition: opacity 0.2s ease-in-out, width 0.2s ease-in-out;
    pointer-events: auto;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        display: block;
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        margin: 0;
        position: relative;
        z-index: 1;
    }

    &:before {
        width: 24px;
        height: 24px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 0;
    }

    &:hover,
    &:focus {
        &:before {
            background-color: ${({ theme }) => theme.root.colors.background.sheetOrModal};
        }
    }

    &:active {
        &:before {
            background-color: ${({ theme }) => theme.root.colors.background.sheetOrModal};
        }
    }
`;

export const ParticipantMenuWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
`;

export const MenuItemIconWrapper = styled.span`
    display: flex;
    align-items: center;
    flex-shrink: 0;

    svg {
        fill-opacity: 0.55;
    }
`;
